import React from "react";
import Grid2 from "@mui/material/Unstable_Grid2/Grid2";
import SearchInput from "app/components/SearchInput";
import { LEFT_SPACING } from "utils/constants";

const Header = () => {
  return (
    <Grid2 container paddingLeft={LEFT_SPACING}>
      <Grid2 xs={4}>
        <SearchInput />
      </Grid2>
    </Grid2>
  );
};

export default Header;
